<template>
  <section class="page">
    <div class="page-header">
      <div class="page-header-start">
        <h3 class="page-title">Banners</h3>
        <button
          class="button primary small"
          @click="$router.push({ name: 'add-banner', query: { id: '' } })"
        >
          <i class="fad fa-plus"></i>Add
        </button>
      </div>

      <div class="page-header-end">
        <p class="datepicker">
          <span class="label">Select Month</span>
          <span>
            <date-picker
              v-model="monthYear"
              type="month"
              valueType="format"
              placeholder="YYYY/MM"
            ></date-picker>
            <small style="color: red">{{ msg }}</small>
          </span>
        </p>

        <div class="button-group">
          <button
            @click="downloadTemplate()"
            :class="['button small primary', { 'is-loading': isLoading }]"
          >
            <i class="fad fa-file-excel"></i>Export
          </button>
        </div>
      </div>
    </div>

    <div class="tabs-container">
      <div class="tabs">
        <div class="tabs-start">
          <router-link
            :to="{
              query: {
                type: 'all',
                p: $route.query.p,
                q: $route.query.q,
                s: $route.query.s,
              },
            }"
            class="tab"
            >All</router-link
          >
          <router-link
            :to="{
              query: {
                type: 'online',
                p: $route.query.p,
                q: $route.query.q,
                s: $route.query.s,
              },
            }"
            class="tab"
            >Online</router-link
          >
          <router-link
            :to="{
              query: {
                type: 'offline',
                p: $route.query.p,
                q: $route.query.q,
                s: $route.query.s,
              },
            }"
            class="tab"
            >Offline</router-link
          >
          <router-link
            :to="{
              query: {
                type: 'expired',
                p: $route.query.p,
                q: $route.query.q,
                s: $route.query.s,
              },
            }"
            class="tab"
            >Expired</router-link
          >
        </div>
        <div class="tabs-end">
          <div class="search select">
            <select v-model="search" class="input" @change="textSearch">
              <option value="" selected="selected">All Banner Type</option>
              <option
                v-for="(item, idx) in banner"
                :key="idx"
                :value="item.name"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="page-content">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import { GET_REUSE } from "@/graphql/manage/query";
import { apolloClient } from "@/services/apollo-client";
import moment from "moment";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data: () => ({
    search: [],
    banner: [],
    monthYear: "",
    msg: "",
    isLoading: false,
  }),
  methods: {
    textSearch() {
      this.$router
        .push({ query: { ...this.$route.query, s: this.search } })
        .catch(() => {});
      // window.location.reload();
    },
    async queryBanner() {
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          type: "BannerType",
          page: 1,
          perPage: 1000,
        },
      });
      this.banner = res.data.getReuse.reuseType;
      this.search = "";
    },
    async downloadTemplate() {
      try {
        if (!this.monthYear) return (this.msg = "Please select month");
        const monthYear = moment(this.monthYear).format("YYYY-MM");
        this.isLoading = true;
        axios.defaults.headers["Authorization"] = this.$store.getters.Token;
        const res = await axios.get(
          `${process.env.VUE_APP_HTTPS_ADMIN}/api/export-catchlog-all-banner?monthYear=${monthYear}`,
          {
            responseType: "blob",
          }
        );
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Activity-Banner.xlsx");
        document.body.appendChild(link);
        link.click();
        this.msg = "";
        this.isLoading = false;
        console.log("completed");
      } catch (err) {
        console.log("error");
        throw new Error(err);
      }
    },
  },
  async created() {
    await this.queryBanner();
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  height: 120px;
  width: auto;
  overflow: hidden;

  img {
    height: 120px;
  }
}

.page-header-end {
  margin-left: auto;
  display: flex;
  align-items: center;

  ul {
    list-style-type: none;
    margin: 0;
    display: flex;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      margin: 0;
      padding: 0%;
      flex-grow: 1;
      margin-left: 10px;

      span {
        display: block;
        flex-grow: 1;

        &:first-child {
          margin-right: 10px;
        }

        input.input {
          font-size: var(--md-font);
          padding: 0 10px;
          background-color: #fff;
          border: none;
        }
      }
    }
  }
}
</style>
